import styled from 'styled-components';
import appTheme from '../../../themes/Theme';
import FormControlLabel from '@material-ui/core/FormControlLabel';

export const StyledFormControlLabel = styled(FormControlLabel)`
  & > span > span{
    color: ${appTheme.radioColor};
  }
  & span.MuiFormControlLabel-label.Mui-disabled{
    color: gray;
  }
`;